import React, { Component } from "react";

// Helper
import { currencyFormatter } from "../../../../helpers/stringControllers";

// Redux
import { connect } from "react-redux";
import { setToast } from "./../../../../redux/actions/toast";

class FundWalletForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fundWalletForm: {
        interest: this.props.wallet.balance,
        amount: this.props.systemConfig.investment.min,
        amountWithInterest: this.props.systemConfig.investment.min,
      },
    };

    this.fundWalletForm = React.createRef();
  }

  payWithPaystack = (investmentAmount) => {
    const { first_name, last_name, email } = this.props.profile;

    const handler = window.PaystackPop.setup({
      key: "pk_test_2391540e7a251ade4e952d5b6ff70cc4495d88ea",
      email: email,
      amount: investmentAmount * 100,
      ref: "" + Math.floor(Math.random() * 1000000000 + 1),
      currency: "NGN",
      firstname: first_name,
      lastname: last_name,
      metadata: {
        custom_fields: [
          {
            funder_invest: "9k329htrx2h7",
          },
        ],
      },
      callback: (response) => {
        this.props.setToast(
          "success",
          "Transaction success with ref: " + response.reference
        );
        this.props.onCloseModal();
      },
      onClose: () => {
        this.props.onCloseModal();
      },
    });
    handler.openIframe();
  };

  fundWalletInputChange = (e) => {
    let { name, value } = e.target;
    this.setState({
      fundWalletForm: {
        ...this.state.fundWalletForm,
        [name]: value,
      },
    });
  };

  amountSliderChangeHandler = (e) => {
    // Update the current slider value (each time you drag the slider handle)
    let sliderValue = e.target.value;
    let amount = parseInt(sliderValue);
    let interest = amount * 0.03;
    let amountWithInterest = amount + interest;
    this.setState({
      fundWalletForm: {
        ...this.state.fundWalletForm,
        [e.target.name]: amount,
        interest,
        amountWithInterest,
      },
    });
  };

  render() {
    // From state
    const {
      fundWalletForm: { interest, amountWithInterest, amount },
    } = this.state;
    const formattedInterest = currencyFormatter(interest);
    const formattedAmountWithInterest = currencyFormatter(amountWithInterest);
    const formattedInvestmentAmount = currencyFormatter(amount);

    // From props
    const { available_balance } = this.props.profile;
    const { min, max, step } = this.props.systemConfig.investment;
    const balance = currencyFormatter(parseInt(available_balance));
    const minVal = currencyFormatter(min),
      maxVal = currencyFormatter(max);

    return (
      <div className="Modal__dialog animated slideInDown" role="document">
        <div className="FundWalletForm Modal__content">
          <div className="Modal__body">
            <h3 className="text-center m-b-1 Modal__title">Fund Wallet</h3>
            <form>
              <div className="row">
                <div className="col-xs-6">
                  <label className="label-txt">Current Wallet Balance</label>
                </div>
                <div className="col-xs-6">
                  <div className="form-group inputWithIcon">
                    <input
                      type="text"
                      className="user__form form-control"
                      readOnly
                      value={balance}
                    />
                  </div>
                </div>
              </div>

              <label className="label-txt">Investment Range</label>
              <div className="range-values">
                <span className="min-val">
                  <strong>{minVal}</strong>
                </span>
                <span className="max-val">
                  <strong>{maxVal}</strong>
                </span>
                <div className="clearfix"></div>
              </div>

              <div className="form-group">
                <input
                  type="range"
                  step={step}
                  min={min}
                  max={max}
                  className="slider"
                  onChange={(e) => {
                    this.amountSliderChangeHandler(e);
                  }}
                  value={amount}
                  name="amount"
                />
              </div>

              <div className="row">
                <div className="col-xs-6">
                  <label className="label-txt">Select Amount</label>
                </div>
                <div className="col-xs-6">
                  <div className="form-group inputWithIcon">
                    <input
                      type="text"
                      readOnly
                      className="user__form form-control"
                      value={formattedInvestmentAmount}
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-xs-6">
                  <label className="label-txt">Interest Amount</label>
                </div>
                <div className="col-xs-6">
                  <div className="form-group inputWithIcon">
                    <input
                      type="text"
                      readOnly
                      className="user__form form-control"
                      value={formattedInterest}
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-xs-6">
                  <label className="label-txt">
                    Total Amount with interest
                  </label>
                </div>
                <div className="col-xs-6">
                  <div className="form-group inputWithIcon">
                    <input
                      type="text"
                      readOnly
                      className="user__form form-control"
                      value={formattedAmountWithInterest}
                    />
                  </div>
                </div>
              </div>
              <div className="Form__action-buttons m-t-1">
                <button
                  type="button"
                  data-form="fundWalletForm"
                  className="btn zoom-element btn login-btn m-0 mr-auto"
                  onClick={this.props.onCloseModal}
                  data-dismiss="modal"
                >
                  <i className="fas fa-chevron-circle-left" />
                  &nbsp; Back to Dashboard
                </button>
                <button
                  type="button"
                  data-form="fundWalletForm"
                  className="btn btn-proceed zoom-element btn login-btn m-0 ml-auto"
                  onClick={(e) => this.payWithPaystack(amount)}
                >
                  <i className="far fa-credit-card"></i>
                  &nbsp; Pay with Paystack
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { systemConfig } = state.systemReducer;
  const { wallet, loading, error } = state.walletReducer;

  return {
    wallet,
    loading,
    error,
    systemConfig,
  };
};

export default connect(mapStateToProps, { setToast })(FundWalletForm);
